import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { NotificationService } from '@mydocma/component-library/src/lib/notification';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private showNotifications: boolean;

  constructor(private readonly injector: Injector) {
    const params = new URLSearchParams(window.location.search);
    if (params.has('debugErrors')) {
      const value = params.get('debugErrors') !== 'false';
      localStorage.setItem('debugErrors', String(value));
    }
    this.showNotifications = localStorage.getItem('debugErrors') === 'true';
  }

  private static readonly SUPPRESSED_PATTERNS = [
    'NG0100',
    'ExpressionChangedAfterItHasBeenCheckedError',
    'ResizeObserver loop',
    "Cannot read properties of null (reading '",
  ];

  handleError(error: any): void {
    console.error(error);

    if (!this.showNotifications) return;

    const message = error?.message || error?.rejection?.message || '';
    const isSuppressed = GlobalErrorHandler.SUPPRESSED_PATTERNS.some(p => message.includes(p));
    if (isSuppressed) return;

    try {
      const notificationService = this.injector.get(NotificationService);
      notificationService.error('An unexpected error occurred');
    } catch {
    }
  }
}
